(function () {
  'use strict';

  angular
    .module('crewWaterConsumption')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('crewWaterConsumption', {
        url: '/crew-water-consumption',
        views : {
        	'crewWaterConsumptionView' : {
        		templateUrl: 'crew-water-consumption/views/crew-water-consumption.tpl.html',
                controller: 'CrewWaterConsumptionCtrl',
                controllerAs: 'crewWaterConsumption'
        	}
        }
      });
  }
}());
